import React, { useState, useEffect, useRef, useCallback } from "react";
import { Col, Container, Modal, Row, Button, Form, Spinner } from "react-bootstrap";
import { Icon } from "@iconify/react";
import APICom from "../../../utils/helpers/APICom";
import AssignAction from "../AssignAction";
import UnAssignAffiliateAction from "../UnAssignAffiliateAction";
import MultiSelectDropdown from "../../Controls/multiselectdropdown";
import { useSelector, useDispatch } from "react-redux";
import { HotKeys } from "react-hotkeys";
import { setSmartDevicesCache, SetLoading } from '../../../features/common/SmartDevicesSlice';

const defaultNoDataAlert = {
  show: false,
  alertTitle: "",
  alertMsg: "",
};

const BrokerActionsDialog = (props) => {
  const isSmartDeviceDataFetchingInProgress = useRef(false);
  const chkVehicleRequiredRef = useRef(true);
  const [ShowGridLoader, setShowGridLoader] = useState(false);
  const { SmartDevicesData, lastFetchedSmartDevicesData, isLoadingSmartDeviceData } = useSelector((store) => store.SmartDevices);
  const dispatch = useDispatch();
  const { DispatchVehicleData, DispatchDriverData, AffiliateData, BrokerServingAffiliatesData, ASCSSettingData, isLoading } = useSelector((store) => store.combinedata);
  const [confimAlert, setConfirmAlert] = useState({
    show: false, alertTitle: '', alertMsg: '', btnCancelText: 'No',
    btnOkText: 'Yes', onOkFunction: ''
  });
  const [vehicleFilterMultiSelect, setVehicleFilterMultiSelect] = useState({
    options: [],
    DropdownMode: "rS",
    styles: { width: "98%", marginLeft: "0px" },
  });
  const [driverFilterMultiSelect, setDriverFilterMultiSelect] = useState({
    options: [],
    DropdownMode: "rS",
    styles: { width: "98%", marginLeft: "0px" },
  });
  const [selectedVehicle, setSelectedVehicle] = useState("-1");
  const [selectedDriver, setSelectedDriver] = useState("-1");

  const defaultNoDataAlertRef = useRef(defaultNoDataAlert);
  const [noDataAlert, setNoDataAlert] = useState(defaultNoDataAlert);
  const showAlert = useCallback((title, message) => {
    setNoDataAlert((prevState) => {
      if (prevState.alertTitle === title && prevState.alertMsg === message && prevState.show) {
        return prevState;
      }
      return { show: true, alertTitle: title, alertMsg: message };
    });
  }, []);
  const resetAlert = useCallback(() => {
    setNoDataAlert((prevState) => {
      if (!prevState.show) return prevState;
      return defaultNoDataAlertRef.current;
    });
  }, []);



  const [selectedAffiliate, setSelectedAffiliate] = useState(() => { "-1" });
  const [displayNoDataAlert, setDisplayNoDataAlert] = useState(false);
  const [showBrokerActionsDialog, setShowBrokerActionsDialog] = useState(false);
  const [numOfGroups, setNumOfGroups] = useState(0);
  const [tripsNumber, setTripsNumber] = useState("");
  const [numOfSelectedTrips, setNumOfSelectedTrips] = useState("");
  const [numOfTrips, setNumOfTrips] = useState("");

  const [SmartDevices, setSmartDevices] = useState([]);

  const [pVehicleType, setpVehicleType] = useState("");
  const [pStatus, setpStatus] = useState("");
  const [pStatusColor, setpStatusColor] = useState("");
  const [pDriverName, setpDriverName] = useState("");
  const [pManualDriverVehicleChange, setpManualDriverVehicleChange] = useState(false);

  const [invokeAssignComponent, setInvokeAssignComponent] = useState(false);
  const [invokeUnAssignAffiliateComponent, setInvokeUnAssignAffiliateComponent] = useState(false);
  const [isUnAssignAffiliateProcessing, setUnAssignAffiliateProcessing] = useState(false);
  const [isAssignAffiliateProcessing, setAssignAffiliateProcessing] = useState(false);
  const [vehicleRequired, setVehicleRequired] = useState(true); // Default checked
  const [ComingFromBroker, setComingFromBroker] = useState(false); // Default checked
  const [PartnerAffiliateID, setPartnerAffiliateId] = useState(null); // Default checked
  const [BrokerActions, setBrokerActions] = useState(false);
  const [TransferActions, setTransferActions] = useState(false);
  const [isTransferringAffiliate, setTransferringAffiliate] = useState(false);

  const handleCheckboxChange = () => {
    setVehicleRequired(!vehicleRequired);
  };

  useEffect(() => {
    console.log("Broker Actions invoked");
    const fetSmartDeviceData = async () => {
      await LoadSmartDevices(-1, -1);
    }
    fetSmartDeviceData();
    return () => {
      props.setGridRefreshPaused(false);
    }
  }, [])

  useEffect(() => {
    try {
      if (props.GridRowData && Array.isArray(props.GridRowData) && props.GridRowData.length > 0) {
        const filteredAffiliates = BrokerServingAffiliatesData?.filter(
          (aff) => String(aff.iBrokerAffiliateID) === String(props.GridRowData[0].iSRATSPID)
        );

        if (filteredAffiliates?.length > 0) {
          setBrokerActions(false);
          setTransferActions(true);
          setComingFromBroker(true);
          const receiverAffiliate = filteredAffiliates?.filter(
            (aff) => String(aff.AffiliateID) === String(props.GridRowData[0].RequestAffiliateID)
          );
          if (receiverAffiliate?.length > 0) {
            setSelectedAffiliate(receiverAffiliate[0].AffiliateID);
            let DispatchMethod = GetDispatchMethodByAffiliateID(receiverAffiliate[0].AffiliateID);
            if (DispatchMethod === "1" || DispatchMethod === "2") {
              setVehicleRequired(false);
            }
          }
          else {
            setVehicleRequired(false);
          }
        }
        else {
          const GetPartnerAffiliateId = GetFamilyAffiliateID(props.GridRowData[0].iSRATSPID)
          let DispatchMethod = GetDispatchMethodByAffiliateID(props.GridRowData[0].iSRATSPID);
          if (DispatchMethod === "1" || DispatchMethod === "2") {
            setVehicleRequired(false);
          }
          if (GetPartnerAffiliateId !== -1) {
            setSelectedAffiliate(props.GridRowData[0].iSRATSPID);
            setTransferActions(false);
            setBrokerActions(true);
            setComingFromBroker(false);
            setPartnerAffiliateId(GetPartnerAffiliateId);
          }
        }
      }
    }
    catch (err) { console.log(err); }

  }, [props.GridRowData]);

  function DisableTransferButton(){
    try {
      if(selectedAffiliate == props.GridRowData[0].iSRATSPID || selectedAffiliate == -1){
        setTransferActions(true);
      }
      else{
        setTransferActions(false);
      }
    } catch (error) {
      
    }
  }


  useEffect(() => {
    try {
      DisableTransferButton();
      resetAlert();
      const rowData = props.GridRowData;
      let VehiclesOptionsSelected = [];
      let DriverOptionsSelected = [];
      let pSelectedVehicleID = -1;
      let pSelectedDriverID = -1;

      const fetchData = async () => {
        setShowBrokerActionsDialog(true);

        await LoadSmartDevices(VehiclesOptionsSelected.length > 0 ? VehiclesOptionsSelected[0].value : -1,
          DriverOptionsSelected.length > 0 ? DriverOptionsSelected[0].value : -1
        );

        if (!rowData || rowData.length === 0) {
          showAlert('No trip selected', 'Please select a trip to perform Broker Action.');
          setDisplayNoDataAlert(true);
          setShowBrokerActionsDialog(false);
        }
        else {
          const uniqueGroups = new Set();
          let tripsNumberConcatenated = "";

          rowData.forEach((row) => {
            const vRoute = row?.vRoute
            const group = row.Group;
            const confirmationNo = row.ConfirmationNo;
            uniqueGroups.add(group);

            if (tripsNumberConcatenated) {
              tripsNumberConcatenated += ", " + confirmationNo;
            } else {
              tripsNumberConcatenated = confirmationNo;
            }
          });

          setNumOfSelectedTrips(props.numOfTripsInRoute);
          setNumOfTrips(rowData?.length);
          setNumOfGroups(uniqueGroups.size);
          setTripsNumber(tripsNumberConcatenated);

          if (DispatchVehicleData !== undefined && DispatchVehicleData !== null) {
            let VehiclesOptions = [];
            try {
              let iAssignedVehicleID_temp = Number(
                props.GridRowData[0].iAssignedVehicleId
              );
              let iSpecialVehicleID_temp = Number(
                props.GridRowData[0].iSpecialVehicleId
              );
              if (
                !isNaN(iAssignedVehicleID_temp) &&
                Number.isInteger(iAssignedVehicleID_temp) &&
                iAssignedVehicleID_temp > 0
              ) {
                pSelectedVehicleID = iAssignedVehicleID_temp;
              } else if (
                !isNaN(iSpecialVehicleID_temp) &&
                Number.isInteger(iSpecialVehicleID_temp) &&
                iSpecialVehicleID_temp > 0
              ) {
                pSelectedVehicleID = iSpecialVehicleID_temp;
              }
            } catch (e) { }

            try {
              let iAssignedDriverID_temp = Number(
                props.GridRowData[0].AssignedDriverId
              );
              let iSpecialDriverID_temp = Number(
                props.GridRowData[0].iSpecialDriverId
              );
              if (
                !isNaN(iAssignedDriverID_temp) &&
                Number.isInteger(iAssignedDriverID_temp) &&
                iAssignedDriverID_temp > 0
              ) {
                pSelectedDriverID = iAssignedDriverID_temp;
              } else if (
                !isNaN(iSpecialDriverID_temp) &&
                Number.isInteger(iSpecialDriverID_temp) &&
                iSpecialDriverID_temp > 0
              ) {
                pSelectedDriverID = iSpecialDriverID_temp;
              }
            } catch (e) { }

            let DispatchVehiclesByAffiliate = DispatchVehicleData[selectedAffiliate];
            if (DispatchVehiclesByAffiliate && DispatchVehiclesByAffiliate !== "") {
              VehiclesOptions.push({
                label: "Select",
                value: "-1",
              });
              JSON.parse(DispatchVehiclesByAffiliate).map((item) => {
                VehiclesOptions.push({
                  label: item.VehicleNumber,
                  value: item.VehicleID,
                });
                if (
                  pSelectedVehicleID > 0 &&
                  item.VehicleID === pSelectedVehicleID
                ) {
                  VehiclesOptionsSelected.push({
                    label: item.VehicleNumber,
                    value: item.VehicleID,
                  });
                }
              });
            }

            if (!DispatchVehiclesByAffiliate || DispatchVehiclesByAffiliate === "") {
              setVehicleFilterMultiSelect({
                ...vehicleFilterMultiSelect,
                options: [],
                selectedValues: [],
              });

              setpVehicleType("");
              setpStatus("");
              setpDriverName("");
            }
            if (VehiclesOptions.length > 0 && VehiclesOptionsSelected.length == 0) {
              setVehicleFilterMultiSelect({
                ...vehicleFilterMultiSelect,
                ...{ options: VehiclesOptions },
              });
            }

            else if (VehiclesOptions.length > 0 && VehiclesOptionsSelected.length > 0) {
              setVehicleFilterMultiSelect({
                ...vehicleFilterMultiSelect,
                ...{
                  options: VehiclesOptions,
                  selectedValues: VehiclesOptionsSelected,
                },
              });
            }
          }
          if (DispatchDriverData !== undefined && DispatchDriverData !== null) {
            let DriversOptions = [];
            let DispatchDriverByAffiliate = DispatchDriverData[selectedAffiliate];
            if (DispatchDriverByAffiliate && DispatchDriverByAffiliate !== "") {
              DriversOptions.push({
                label: "Select",
                value: "-1",
              });
              JSON.parse(DispatchDriverByAffiliate).map((item) => {
                DriversOptions.push({
                  label: item.DriverInfo,
                  value: item.DriverID,
                });
                if (pSelectedDriverID > 0 && item.DriverID === pSelectedDriverID) {
                  DriverOptionsSelected.push({
                    label: item.DriverInfo,
                    value: item.DriverID,
                  });
                }
              });
            }

            if (!DispatchDriverByAffiliate || DispatchDriverByAffiliate === "") {
              setDriverFilterMultiSelect({
                ...driverFilterMultiSelect,
                ...{
                  options: [],
                  selectedValues: [],
                },
              });

              setpVehicleType("");
              setpStatus("");
              setpDriverName("");
            }
            if (DriversOptions.length > 0 && DriverOptionsSelected.length == 0) {
              setDriverFilterMultiSelect({
                ...driverFilterMultiSelect,
                ...{ options: DriversOptions },
              });
            } else if (
              DriversOptions.length > 0 &&
              DriverOptionsSelected.length > 0
            ) {
              setDriverFilterMultiSelect({
                ...driverFilterMultiSelect,
                ...{
                  options: DriversOptions,
                  selectedValues: DriverOptionsSelected,
                },
              });
            }
          }
        }
      };
      fetchData();
    }
    catch (err) {
      console.log(err);
    }
  }, [selectedAffiliate]);


  useEffect(() => {
    try {
      
      if (selectedVehicle > 0) {
        VehicleSelectFunction();
      }
      else {
        resetDriverMultiSelect();
      }
    }
    catch (err) { console.log(err); }

  }, [selectedVehicle]);

  useEffect(() => {
    try {
      
      if (selectedDriver !== "-1" && parseInt(selectedDriver) > 0) {
        DriverSelectFunction();
      }
    }
    catch (err) { console.log(err); }

  }, [selectedDriver]);

  const keyMap = {
    ALT_A: 'alt+a',
    ALT_U: 'alt+u',
    ALT_T: 'alt+t'
  };

  const resetDriverMultiSelect = () => {
    try {
      let DriversOptions = []
      DriversOptions.push({ label: "", value: "" });
      setDriverFilterMultiSelect({
        ...driverFilterMultiSelect,
        ...{ selectedValues: DriversOptions },
      });
    } catch (error) {

    }
  }

  const handleHotKeys = (isLoading || isLoadingSmartDeviceData) ? {} : {
    ALT_A: () => {
      handleAssignClick();
    },
    ALT_U: () => {
      handleUnAssignAffiliateClick();
    },
    ALT_T: () => {
      handleBrokerActionTripTransfer();
    }
  };

  const LoadSmartDevices = async (VehicleIDD, DriverIDD) => {

    const currentTime = Date.now();
    const twoMinutes = 5 * 60 * 1000;

    if (SmartDevicesData && lastFetchedSmartDevicesData && currentTime - lastFetchedSmartDevicesData < twoMinutes) {
      setSmartDevices(SmartDevicesData);
      if (VehicleIDD > 0) {
        setSelectedVehicle(VehicleIDD.toString());
      }
      if (DriverIDD > 0) {
        setSelectedDriver(DriverIDD.toString());
      }
      return;
    }
    else {
      if (isSmartDeviceDataFetchingInProgress.current) { return }
      console.log("BrokerActionsdialog: GetSmartDeviceList");
      let requestObj = {
        VehicleID: -1,
      };
      dispatch(SetLoading(true));
      try {
        isSmartDeviceDataFetchingInProgress.current = true;
        let response = await APICom.fetchData("", "TripActions/GetSmartDeviceList", "post", { "Content-Type": "application/json" }, requestObj, null);
        if (response.error === "") {
          let data = response.data;
          dispatch(setSmartDevicesCache({ data: data, name: "SmartDevicesData" }));
          dispatch(setSmartDevicesCache({ data: currentTime, name: "lastFetchedSmartDevicesData" }));
          setSmartDevices(data);
          if (VehicleIDD > 0) {
            setSelectedVehicle(VehicleIDD.toString());
          }
          if (DriverIDD > 0) {
            setSelectedDriver(DriverIDD.toString());
          }
        }
        isSmartDeviceDataFetchingInProgress.current = false;
        dispatch(SetLoading(false));
      } catch (error) {
        isSmartDeviceDataFetchingInProgress.current = false;
        dispatch(SetLoading(false));
      }
    }
  };

  const CheckSmartDeviceCurrentStatusByVehicleId = async (iVehicleID) => {
    let requestObj = {
      VehicleID: iVehicleID,
    };
    let response = await APICom.fetchData("", "TripActions/GetSmartDeviceList", "post", { "Content-Type": "application/json" }, requestObj, null);
    if (response.error === "") {
      return response.data;
    }
  };


  const CheckSmartDeviceCurrentStatusByDriverId = async (iDriverId) => {
    let requestObj = {
      iDriverId: iDriverId,
    };
    let response =
      await APICom.fetchData("", "TripActions/GetSmartDeviceListByDriverId", "post", { "Content-Type": "application/json" }, requestObj, null);
    if (response.error === "") {
      return response.data;
    }
  };


  const GetDriverSelectObjectByDriverID = (driverid) => {
    let DriversOptions = [];
    let DispatchDriverByAffiliate = DispatchDriverData[selectedAffiliate];
    if (DispatchDriverByAffiliate && DispatchDriverByAffiliate !== "" && DispatchDriverByAffiliate !== undefined) {
      JSON.parse(DispatchDriverByAffiliate).map((item) => {
        if (item.DriverID.toString() === driverid.toString()) {
          DriversOptions.push({ label: item.DriverInfo, value: item.DriverID });
        }
      });
    }
    if (DriversOptions.length <= 0) {
      DriversOptions.push({
        label: "",
        value: "",
      });
    }
    return DriversOptions;
  };

  const GetDriverNameByDriverID = (driverid) => {
    let DriversName = "";
    let DispatchDriverByAffiliate = DispatchDriverData[selectedAffiliate];
    if (DispatchDriverByAffiliate && DispatchDriverByAffiliate !== "" && DispatchDriverByAffiliate !== undefined) {
      JSON.parse(DispatchDriverByAffiliate).map((item) => {
        if (item.DriverID.toString() === driverid.toString()) {
          DriversName = item.DriverName;
        }
      });
    }
    return DriversName;
  };

  const GetVehicleSelectObjectByVehicleID = (VehicleID) => {
    console.log("#### VehicleID ####", VehicleID);
    let VehiclesOptions = [];
    let DispatchVehiclesByAffiliate = DispatchVehicleData[selectedAffiliate];
    if (DispatchVehiclesByAffiliate && DispatchVehiclesByAffiliate !== "" && DispatchVehiclesByAffiliate !== undefined) {
      JSON.parse(DispatchVehiclesByAffiliate).map((item) => {
        if (item.VehicleID.toString() === VehicleID.toString()) {
          VehiclesOptions.push({
            label: item.VehicleNumber,
            value: item.VehicleID,
          });
        }
      });
    }
    if (VehiclesOptions.length <= 0) {
      VehiclesOptions.push({
        label: "",
        value: "",
      });
      setpVehicleType("");
      setpStatus("");
      setpDriverName("");
    }

    return VehiclesOptions;
  };

  const VehicleSelectCallback = (_selectedVehicleID) => {
    console.log("#### VehicleID ####", _selectedVehicleID);
    setSelectedVehicle(_selectedVehicleID.toString());
    setpManualDriverVehicleChange(true);
    setVehicleFilterMultiSelect({
      ...vehicleFilterMultiSelect,
      ...{
        selectedValues: GetVehicleSelectObjectByVehicleID(_selectedVehicleID),
      },
    });
  };

  const VehicleSelectFunction = async () => {
    
    let _selectedVehicleID = parseInt(selectedVehicle);
    console.log("#### VehicleID ####", _selectedVehicleID);
    let dispatchMethodVal = 2;
    let _iSpecialVehicleId = props.GridRowData[0] ? props.GridRowData[0]["iSpecialVehicleId"] : 0;
    let _isRequiredVehcile = props.GridRowData[0] ? props.GridRowData[0]["IsVehicleRequired"] : "false";
    if (chkVehicleRequiredRef.current !== undefined) {
      if (parseInt(_iSpecialVehicleId) > 0 && _selectedVehicleID === _iSpecialVehicleId && _isRequiredVehcile && _isRequiredVehcile?.toString() === "true") {
        chkVehicleRequiredRef.current.checked = true;
      }
      else {
        chkVehicleRequiredRef.current.checked = false;
      }
    }
    try {
      dispatchMethodVal = parseInt(
        JSON.parse(
          ASCSSettingData[parseInt(props.GridRowData[0].iSRATSPID)]
        ).filter(function (item) {
          return item["SubTitle"] === "DispatchMethod";
        })[0].value
      );
    } catch (e) { }
    try {
      dispatchMethodVal = dispatchMethodVal.toString();
    } catch (e) {
      dispatchMethodVal = "2";
    }
    try {
      let p_selectedDriverID = -1;
      let p_Name = "";
      let p_Driver_Num = "";
      if (
        parseInt(dispatchMethodVal) === 0 ||
        parseInt(dispatchMethodVal) === 2
      ) {
        if (parseInt(_selectedVehicleID) > 0) {
          let mSDobject = null;
          let pcolor = "#FF0000";
          let p_vType = "";
          let p_State = "";
          SmartDevices.every(function (sd) {
            if (sd.IVEHICLEID.toString() === _selectedVehicleID.toString()) {
              mSDobject = sd;
              return false;
            }
            return true;
          });
          if (!mSDobject) {
            await CheckSmartDeviceCurrentStatusByVehicleId(_selectedVehicleID)
              .then(result => {
                mSDobject = result[0];
                console.log("Smart Device Data:", mSDobject);

                p_State = mSDobject["STATE"];
                if (mSDobject.bOnBreak.toString().toUpperCase() == "TRUE") {
                  p_State = "OnBreak";
                  pcolor = "#FF0000";
                } else if (
                  mSDobject.bUnAvailable.toString().toUpperCase() == "TRUE"
                ) {
                  p_State = "UnAvailable";
                  pcolor = "#FF0000";
                } else {
                  pcolor = "#000000";
                }
                p_vType = mSDobject["VEH TYPE"];
                p_Name = mSDobject["DRIVER NAME"];
                p_Driver_Num = mSDobject["DRIVER NUM"];
                p_selectedDriverID = mSDobject.IDRIVERID;
                setSelectedDriver(p_selectedDriverID)

                setpVehicleType(p_vType);
                setpStatus(p_State);
                setpStatusColor(pcolor);
                if (pManualDriverVehicleChange === true) {
                  setpDriverName(p_Name);
                }
                if (
                  driverFilterMultiSelect.options.length > 0 &&
                  pManualDriverVehicleChange === true
                ) {
                  if (p_selectedDriverID > 0) {
                    let DriversOptions = []
                    DriversOptions.push({ label: p_Driver_Num + " - " + p_Name, value: p_selectedDriverID });
                    setDriverFilterMultiSelect({
                      ...driverFilterMultiSelect,
                      ...{
                        selectedValues: DriversOptions

                      },
                    });
                  }
                }
              })
              .catch(error => {
                console.error("Error fetching Smart Device data:", error);
              });
          }
          if (mSDobject != null) {
            p_State = mSDobject["STATE"];
            if (mSDobject.bOnBreak.toString().toUpperCase() == "TRUE") {
              p_State = "OnBreak";
              pcolor = "#FF0000";
            } else if (
              mSDobject.bUnAvailable.toString().toUpperCase() == "TRUE"
            ) {
              p_State = "UnAvailable";
              pcolor = "#FF0000";
            } else {
              pcolor = "#000000";
            }
            p_vType = mSDobject["VEH TYPE"];
            p_Name = mSDobject["DRIVER NAME"];
            p_Driver_Num = mSDobject["DRIVER NUM"];
            p_selectedDriverID = mSDobject.IDRIVERID;
            setSelectedDriver(p_selectedDriverID);

            setpVehicleType(p_vType);
            setpStatus(p_State);
            setpStatusColor(pcolor);
            if (pManualDriverVehicleChange === true) {
              setpDriverName(p_Name);
            }

            if (
              driverFilterMultiSelect.options.length > 0 &&
              pManualDriverVehicleChange === true
            ) {
              if (p_selectedDriverID > 0) {
                let DriversOptions = []
                DriversOptions.push({ label: p_Driver_Num + " - " + p_Name, value: p_selectedDriverID });
                setDriverFilterMultiSelect({
                  ...driverFilterMultiSelect,
                  ...{
                    selectedValues: DriversOptions

                  },
                });
              }
            }
          }
        }
      }
    } catch (e) {

    }
  };

  const DriverSelectCallback = (_selectedDriverID) => {
    setSelectedDriver(_selectedDriverID.toString());
    setpManualDriverVehicleChange(true);
    setDriverFilterMultiSelect({
      ...driverFilterMultiSelect,
      ...{
        selectedValues: GetDriverSelectObjectByDriverID(_selectedDriverID),
      },
    });
  };

  const DriverSelectFunction = async () => {
    
    let _selectedDriverID = parseInt(selectedDriver);
    let dispatchMethodVal = 2;
    try {
      dispatchMethodVal = parseInt(
        JSON.parse(
          ASCSSettingData[parseInt(props.GridRowData[0].iSRATSPID)]
        ).filter(function (item) {
          return item["SubTitle"] === "DispatchMethod";
        })[0].value
      );
    } catch (e) { }
    try {
      dispatchMethodVal = dispatchMethodVal.toString();
    } catch (e) {
      dispatchMethodVal = "2";
    }
    try {
      setpDriverName(GetDriverNameByDriverID(_selectedDriverID));
    } catch (e) { }
    try {
      let p_selectedVehicleID = -1;
      let p_vNum = -1;
      if (
        parseInt(dispatchMethodVal) === 1 ||
        parseInt(dispatchMethodVal) === 2
      ) {
        if (parseInt(_selectedDriverID) > 0) {
          let mSDobject = null;
          let pcolor = "#FF0000";
          let p_vType = "";
          let p_Name = "";
          let p_State = "";
          SmartDevices.every(function (sd) {
            if (sd.IDRIVERID.toString() === _selectedDriverID.toString()) {
              mSDobject = sd;
              return false;
            }
            return true;
          });
          if (!mSDobject) {
            await CheckSmartDeviceCurrentStatusByDriverId(_selectedDriverID)
              .then(result => {
                if (result.length > 0) {
                  mSDobject = result[0]
                  p_State = mSDobject["STATE"];
                  if (mSDobject.bOnBreak.toString().toUpperCase() === "TRUE") {
                    p_State = "OnBreak";
                    pcolor = "#FF0000";
                  } else if (
                    mSDobject.bUnAvailable.toString().toUpperCase() === "TRUE"
                  ) {
                    p_State = "UnAvailable";
                    pcolor = "#FF0000";
                  } else {
                    pcolor = "#000000";
                  }
                  p_vType = mSDobject["VEH TYPE"];
                  p_Name = mSDobject["DRIVER NAME"];
                  p_vNum = mSDobject["VEH NUM"];
                  p_selectedVehicleID = mSDobject.IVEHICLEID;


                  setpVehicleType(p_vType);
                  setpStatus(p_State);
                  setpDriverName(p_Name);
                  setpStatusColor(pcolor);


                  if (
                    vehicleFilterMultiSelect.options.length > 0 &&
                    pManualDriverVehicleChange == true
                  ) {
                    let VehiclesOptions = [];
                    if (p_selectedVehicleID > 0) {
                      setSelectedVehicle(p_selectedVehicleID);
                      VehiclesOptions.push({ label: p_vNum, value: p_selectedVehicleID });

                      setVehicleFilterMultiSelect({
                        ...vehicleFilterMultiSelect,
                        ...{
                          selectedValues: VehiclesOptions,
                        },
                      });
                    }
                  }
                }
                else {
                  let VehiclesOptions = [];
                  //VehiclesOptions.push({label: p_vNum,value: -1});
                  setSelectedVehicle("-1");
                  setVehicleFilterMultiSelect({
                    ...vehicleFilterMultiSelect,
                    ...{
                      selectedValues: VehiclesOptions,
                    },
                  });
                }
              })
              .catch(error => {
                console.error("Error fetching Smart Device data:", error);
              });
          }
          if (mSDobject != null) {
            p_State = mSDobject["STATE"];
            if (mSDobject.bOnBreak.toString().toUpperCase() === "TRUE") {
              p_State = "OnBreak";
              pcolor = "#FF0000";
            } else if (
              mSDobject.bUnAvailable.toString().toUpperCase() === "TRUE"
            ) {
              p_State = "UnAvailable";
              pcolor = "#FF0000";
            } else {
              pcolor = "#000000";
            }
            p_vType = mSDobject["VEH TYPE"];
            p_Name = mSDobject["DRIVER NAME"];
            p_vNum = mSDobject["VEH NUM"];
            p_selectedVehicleID = mSDobject.IVEHICLEID;


            setpVehicleType(p_vType);
            setpStatus(p_State);
            setpDriverName(p_Name);
            setpStatusColor(pcolor);

            if (
              vehicleFilterMultiSelect.options.length > 0 &&
              pManualDriverVehicleChange == true
            ) {
              let VehiclesOptions = [];
              if (p_selectedVehicleID > 0) {
                setSelectedVehicle(p_selectedVehicleID);
                VehiclesOptions.push({ label: p_vNum, value: p_selectedVehicleID });

                setVehicleFilterMultiSelect({
                  ...vehicleFilterMultiSelect,
                  ...{
                    selectedValues: VehiclesOptions,
                  },
                });
              }

            }

          }
        }
      }
    } catch (e) { }
  }

  const handleCloseBrokerActionsDialog = () => {
    if (props.setBrokerActionsDialog) {
      setShowBrokerActionsDialog(false);
      props.setBrokerActionsDialog(false);
      props.setGridRefreshPaused(false);
    }
  };

  const handleUnAssignAffiliateClick = () => {
    setUnAssignAffiliateProcessing(true);
    setInvokeUnAssignAffiliateComponent(true);
  }

  const handleAssignClick = (e) => {
    if (parseInt(selectedAffiliate) <= 0) {
      showAlert("Assign Warning", "Please select affiliate from dropdown.");
      setDisplayNoDataAlert(true);
    } else {
      setAssignAffiliateProcessing(true);
      setInvokeAssignComponent(true);
    }
  };

  const GetFamilyAffiliateID = (iSRATSPID) => {
    try {
      const foundAffiliate = AffiliateData.find((item) => item.AffiliateID.toString() === iSRATSPID.toString());
      if (foundAffiliate) {
        return foundAffiliate.iPartnerAffiliateID.toString();
      }
    } catch (error) { }

    return -1;
  };

  const internalATSPTripTransferConfirmation = async () => {
    const gData = props.GridRowData;
    console.log("***  internalATSPTripTransferConfirmation Invoked ***")

    setTransferringAffiliate(true);

    for (let i = 0; i < gData.length; i++) {
      const currentTrip = gData[i];
      const data = {
        "iServiceID": currentTrip["ServiceID"],
        "ManifestNo": currentTrip["vManifestNumber"],
        "isRoute": currentTrip["vManifestNumber"] !== "" ? true : false,
        "iScheduleID": currentTrip["iScheduleID"] !== null ? currentTrip["iScheduleID"] : "-1",
        "iTransferAffiliateID": selectedAffiliate && selectedAffiliate !== "" ? selectedAffiliate : currentTrip.iSRATSPID,
        "bForceTransfer": false,
        "unAssign": false,
        "iVehicleID": "-1",
        "Queue": "",
        "isSchedule": currentTrip["TableSource"]?.toUpperCase() === "FROMONDEMANDTABLE" ? false : true,
      };
      var response = await APICom.fetchData("", "BrokerActions/InternalATSPTripTransferConfirmation", "post", {}, data);
      if (response.data) {
        let result = response.data.message[0];
        let isTranferredProcessed = response.data.message[0]?.bProcessTransfer;
        if (isTranferredProcessed !== undefined) {
          if (String(result.bProcessTransfer).toUpperCase() === "TRUE" || String(result.bProcessTransfer).toUpperCase() === "1") {
            showAlert("Trip Transfer Successful", "Trip transferred successfully.");
            setDisplayNoDataAlert(true);
          }
          else if (String(result.bProcessTransfer).toUpperCase() === "FALSE" || String(result.bProcessTransfer).toUpperCase() === "0") {
            if ((String(result.IsFundingSourceSupported).toUpperCase() === "FALSE" || String(result.IsFundingSourceSupported).toUpperCase() === "")
              && String(result.FSHardWarning).toUpperCase() === "TRUE") {
              showAlert("Transfer Failed", "Account is not supported in transferred affiliate.");
              setDisplayNoDataAlert(true);
            }

            if ((String(result.IsClassOfServiceSupported).toUpperCase() === "" || String(result.IsClassOfServiceSupported).toUpperCase() === "FALSE") &&
              String(result.COSHardWarning).toUpperCase() === true) {
              showAlert("Transfer Failed", "Class of service is not supported in tranferred affiliate.");
              setDisplayNoDataAlert(true);
            }

            if ((String(result.IsPaymentTypeSupported).toUpperCase() === "" || String(result.IsPaymentTypeSupported).toUpperCase() === "FALSE") &&
              result.PTHardWarning === true) {
              showAlert("Transfer Failed", "Payment method is not supported in transferred affiliate.");

              setDisplayNoDataAlert(true);
            }

            if (
              (String(result.IsPaymentTypeSupported).toUpperCase() === "" || String(result.IsVehicleTypeSupported).toUpperCase() === "FALSE") &&
              String(result.PTHardWarning).toUpperCase() === "TRUE") {
              showAlert("Transfer Failed", "Vehicle type is not supported in transferred affiliate.");
              setDisplayNoDataAlert(true);
            }
          }
        }
        else {
          showAlert("Transfer Failed", String(response.data.message));
          setDisplayNoDataAlert(true);
        }
        setTransferringAffiliate(false);
      }
    }
  }

  const handleConfirmOkFunction = () => {
    switch (confimAlert.onOkFunction) {
      case "internalATSPTripTransferConfirmation":
        internalATSPTripTransferConfirmation();
        break;
      case "UnMountBrokerActionsDialogComponent":
        UnMountBrokerActionsDialogComponent();
        break;
      default:
        console.log("No function assigned to confirmation dialog for ok/yes");
        break;
    }
  }

  const handleConfirmOk = () => {
    setConfirmAlert((prevState) => ({ ...prevState, show: false }));
    handleConfirmOkFunction();
  }

  const handleConfirmCancel = () => {
    setConfirmAlert((prevState) => ({ ...prevState, show: false }));
  }

  const handleAffiliateChange = (e) => {
    VehicleSelectCallback("-1");
    DriverSelectCallback("-1");
    setSelectedAffiliate(e.target.value);
    let DispatchMethod = GetDispatchMethodByAffiliateID(e.target.value);
    if (DispatchMethod === "1" || DispatchMethod === "2") {
      setVehicleRequired(false);
    } else {
      setVehicleRequired(true);
    }
  }

  const handleBrokerActionTripTransfer = async (e) => {
    const rowData = props.GridRowData[0];

    let iTransferAffiliateID = selectedAffiliate && selectedAffiliate !== "" ? selectedAffiliate : rowData.iSRATSPID;
    let iRequestAffiliateID = rowData["RequestAffiliateID"];
    let ServiceStatus = rowData["ServiceStatus"];
    let MANIFEST_NO = rowData["vManifestNumber"];
    let CreatedBy = rowData["CreatedBy"].toString();
    let isRoute = false

    if (selectedAffiliate === "") {
      // because the default affiliate of the selected rows will be as default value of dropdown 
      showAlert('Tranfer Warning', 'Trip already belongs to this Affiliate.');
      setDisplayNoDataAlert(true);
    }
    else {
      if (CreatedBy === "(ExternalDispatch)") {
        showAlert('Trip Transfer Restricted', 'Trip transfer to broker affiliate is not allowed!');
        setDisplayNoDataAlert(true);
      }
      else if (MANIFEST_NO !== "") {
        isRoute = true
        const SelectedRowData = props.GridRowData;

        SelectedRowData.forEach((item) => {
          if (iRequestAffiliateID !== item.RequestAffiliateID) {
            showAlert('Transfer Warning', 'Selected trips should be of the same affiliate.');
            setDisplayNoDataAlert(true);
          }

          if (MANIFEST_NO !== item.vManifestNumber) {
            showAlert('Transfer Warning', 'Selected trips should be of the same route.');
            setDisplayNoDataAlert(true);
          }

          if (!["active", "assigned", "dispatched"].includes(item.ServiceStatus?.toLowerCase()) &&
            !item.ServiceStatus?.toLowerCase().includes("cancel") &&
            !item.ServiceStatus?.toLowerCase().includes("noshow")) {
            showAlert('Transfer Warning', 'Only routes having trips with Service Status [active, Assigned, Dispatched] can be transferred.');

            setDisplayNoDataAlert(true);
          }

          if (GetFamilyAffiliateID(item.iSRATSPID) !== GetFamilyAffiliateID(iTransferAffiliateID)) {
            showAlert('Group Assignment Restricted', 'Route can only transfer within the same family');
            setDisplayNoDataAlert(true);
          }

        });

      }
    }

    if (isRoute === true) {
      setConfirmAlert({ show: true, alertTitle: 'Confirm Route Transfer', alertMsg: "Are you sure you want to transfer route?", btnCancelText: 'No', btnOkText: 'Yes', onOkFunction: 'internalATSPTripTransferConfirmation' });

    }
    else if (ServiceStatus?.toLowerCase().includes("active")) {
      setConfirmAlert({ show: true, alertTitle: 'Confirm Trip Transfer', alertMsg: "Are you sure you want to transfer trip?", btnCancelText: 'No', btnOkText: 'Yes', onOkFunction: 'internalATSPTripTransferConfirmation' });

    }
    else if (ServiceStatus?.toLowerCase().includes("assigned") || ServiceStatus?.toLowerCase().includes("dispatched")) {
      setConfirmAlert({ show: true, alertTitle: 'Confirm Trip Transfer', alertMsg: `Trip already in ${ServiceStatus?.toUpperCase()} state and will be unassigned. Are you sure you want to tranfer trip ?`, btnCancelText: 'No', btnOkText: 'Yes', onOkFunction: 'internalATSPTripTransferConfirmation' });

    }
    else {
      showAlert('Trip Transfer', 'Only Trips with Service Status [active] can be transferred.');
      setDisplayNoDataAlert(true);
    }
  };

  const UnMountBrokerActionsDialogComponent = () => {
    if (props.showBrokerActionsDialog) {
      props.setGridRefreshPaused(false);
      props.setBrokerActionsDialog(false);
    }
  };

  const handleAlertModalClose = () => {
    resetAlert();
    setDisplayNoDataAlert(false);
    if (!showBrokerActionsDialog) {
      UnMountBrokerActionsDialogComponent();
    }
  };

  const RefreshGridData = () => {
    if (typeof props.ReloadDataFunction === 'function') {
      props.ReloadDataFunction();
    }
  }

  const GetDispatchMethodByAffiliateID = (AffiliateID) => {
    let dispatchMethodValue = 2;
    if (AffiliateID > 0) {
      try {
        dispatchMethodValue = parseInt(
          JSON.parse(
            ASCSSettingData[parseInt(AffiliateID)]
          ).filter(function (item) {
            return item["SubTitle"] === "DispatchMethod";
          })[0].value
        );
      } catch (e) { }
      try {
        dispatchMethodValue = dispatchMethodValue.toString();
      } catch (e) {
        dispatchMethodValue = "2";
      }
    }
    return dispatchMethodValue;
  }

  const GetDistinctBrokerAffiliates = () =>
  {
    let distinctAffiliates = [];
    try {

      let filteredAffiliates = BrokerServingAffiliatesData?.filter(
        (aff) => String(aff?.iBrokerAffiliateID) === String(props?.GridRowData?.[0]?.iSRATSPID ?? '')
      ).sort((a, b) => {
        if (a?.AffiliateCompany < b?.AffiliateCompany) return -1;
        if (a?.AffiliateCompany > b?.AffiliateCompany) return 1;
        return 0;
      })

      distinctAffiliates = Array.from(
        new Map(
          filteredAffiliates.map(aff => [aff.AffiliateID, aff])
        ).values()
      );
    } catch (error) {
      return [];
    }
    return distinctAffiliates;
  }

  return (
    <>
      <HotKeys keyMap={keyMap} handlers={handleHotKeys}>
        <Modal
          show={showBrokerActionsDialog}
          centered
          onHide={handleCloseBrokerActionsDialog}
          backdrop="static"
          size="lg"
          keyboard={true}
          aria-labelledby="contained-modal-title-vcenter"
        >
          <Modal.Header className="activate_dialog_header_bgcolor" closeButton>
            <Modal.Title className="activate_dialog_title_color user-select-none">
              Broker Actions     {(isLoading || isLoadingSmartDeviceData) ? (<Spinner as="span" animation="border" size="sm" role="status" aria-hidden="true" style={{ marginBottom: "3px" }} />) : ""}
            </Modal.Title>
          </Modal.Header>

          <Modal.Body className="grid-example">
            <Container style={{ pointerEvents: (isLoading || isLoadingSmartDeviceData) ? "none" : "auto", opacity: (isLoading || isLoadingSmartDeviceData) ? 0.5 : 1 }}>
              <Row>
                <h5 className="user-select-none">
                  {" "}
                  <Icon
                    icon="ic:outline-group"
                    color="lightcoral"
                    width="26"
                    height="26"
                  />{" "}
                  Trip Broker Actions
                </h5>
              </Row>
              <Row className="user-select-none">
                <Col className="d-flex">
                  Select Trips:
                  <p className="m-0 mx-2 overflow-hidden fw-bold d-inline-flex py-1" title={tripsNumber} style={{ fontSize: "small", maxHeight: "120px" }}>
                    {(parseInt(numOfTrips))}
                  </p>
                </Col>
                <Col>
                  Groups:<b className="mx-2">{numOfGroups}</b>
                </Col>
                <Col>
                  Total Trips:<b className="mx-2">{numOfSelectedTrips}</b>
                </Col>

              </Row>
              <Row className="justify-content-md-center">
                <Col></Col>
                <Col sm={6}>
                  <Form>
                    <Form.Group controlId="formBasicEmail">
                      <Form.Label>
                        <b className="user-select-none">Transfer To:</b>
                      </Form.Label>
                      <Form.Select
                        disabled={(isLoading || isLoadingSmartDeviceData)}
                        aria-label="Default select example"
                        value={selectedAffiliate ?? ''} // Fallback to empty string if selectedAffiliate is undefined
                        onChange={handleAffiliateChange}
                      >
                        <option value="-1">Select Affiliate</option>
                        {(ComingFromBroker
                          ?
                          GetDistinctBrokerAffiliates()
                          // BrokerServingAffiliatesData
                          //   ?.filter(
                          //     (aff) => String(aff?.iBrokerAffiliateID) === String(props?.GridRowData?.[0]?.iSRATSPID ?? '')
                          //   )
                          //   .sort((a, b) => {
                          //     if (a?.AffiliateCompany < b?.AffiliateCompany) return -1;
                          //     if (a?.AffiliateCompany > b?.AffiliateCompany) return 1;
                          //     return 0;
                          //   })
                          : AffiliateData
                            ?.filter(
                              (aff) => String(aff?.iPartnerAffiliateID) === String(PartnerAffiliateID)
                            )
                            .sort((a, b) => {
                              if (a?.AffiliateCompany < b?.AffiliateCompany) return -1;
                              if (a?.AffiliateCompany > b?.AffiliateCompany) return 1;
                              return 0;
                            })
                        )?.map((aff) => (
                          <option key={aff?.AffiliateID ?? ''} value={aff?.AffiliateID ?? ''}>
                            {aff?.AffiliateCompany ?? 'Unknown Affiliate'} {/* Fallback to 'Unknown Affiliate' if undefined */}
                          </option>
                        ))}
                      </Form.Select>


                    </Form.Group>
                  </Form>
                </Col>
                <Col></Col>
              </Row>
              <Row className="mt-1">
                <Col className="mt-1" sm={{ span: 4, offset: -1 }}>
                  <Button

                    className="tripaction_btn_color tripaction_btn_width"
                    onClick={handleAssignClick}
                    disabled={BrokerActions}
                  >
                    {isAssignAffiliateProcessing ? (
                      <Spinner as="span" animation="border" size="sm" role="status" aria-hidden="true" />
                    ) : (
                      'ASSIGN'
                    )
                    }
                  </Button>
                </Col>
                <Col className="mt-1" sm={{ span: 4, offset: -1 }}>
                  <Button
                    className="tripaction_btn_color tripaction_btn_width"
                    onClick={handleUnAssignAffiliateClick}
                    disabled={BrokerActions || props.GridRowData?.[0]?.TripRequestStatus === "CANCELLED"}

                  >
                    {isUnAssignAffiliateProcessing ? (
                      <Spinner as="span" animation="border" size="sm" role="status" aria-hidden="true" />
                    ) : (
                      'UNASSIGN'
                    )
                    }
                  </Button>
                </Col>
                <Col className="mt-1" sm={{ span: 4, offset: -1 }}>
                  <Button
                    className="tripaction_btn_color tripaction_btn_width"
                    onClick={handleBrokerActionTripTransfer}
                    disabled={TransferActions}

                  >

                    {isTransferringAffiliate ? (
                      <Spinner as="span" animation="border" size="sm" role="status" aria-hidden="true" />
                    ) : (
                      'TRANSFER'
                    )
                    }
                  </Button>
                </Col>
              </Row>
              <Row className="tripaction_btn_seperator"></Row>
              {(isLoading || isLoadingSmartDeviceData) ? (<Row></Row>) :
                <Row>
                  {

                    GetDispatchMethodByAffiliateID(selectedAffiliate) === "0" ? (
                      <>
                        <Col xs={6} md={6}>
                          <b className="user-select-none">Select Vehicle:</b>
                          <MultiSelectDropdown
                            options={vehicleFilterMultiSelect}
                            showCheckbox={false}
                            SelectionChangeCallback={VehicleSelectCallback}
                          ></MultiSelectDropdown>
                        </Col>
                        <Col xs={6} md={6}>
                          <b className="user-select-none">Select Driver:</b>
                          <MultiSelectDropdown
                            options={driverFilterMultiSelect}
                            SelectionChangeCallback={DriverSelectCallback}
                          ></MultiSelectDropdown>
                        </Col>
                      </>
                    ) :
                      (
                        <>
                          <Col xs={6} md={6}>
                            <b className="user-select-none">Select Driver:</b>
                            <MultiSelectDropdown
                              options={driverFilterMultiSelect}
                              SelectionChangeCallback={DriverSelectCallback}
                            ></MultiSelectDropdown>
                          </Col>
                          <Col xs={6} md={6}>
                            <b className="user-select-none">Select Vehicle:</b>
                            <MultiSelectDropdown
                              options={vehicleFilterMultiSelect}
                              showCheckbox={false}
                              SelectionChangeCallback={VehicleSelectCallback}
                            ></MultiSelectDropdown>
                          </Col>
                        </>
                      )}
                </Row>
              }
              <Row className="user-select-none">
                <Col>
                  <b>Type : </b>
                  {pVehicleType}
                </Col>
                <Col>
                  <b style={{ color: pStatusColor }}>Status : </b>
                  {pStatus}
                </Col>
                <Col>
                  <b>Name : </b>
                  {pDriverName}
                </Col>
              </Row>
              <Row className="tripaction_btn_seperator"></Row>
              <Row>
                <Col xs={6} md={6} className="user-select-none">
                  <Form>
                    <Form.Check
                      type="checkbox"
                      id="chkVehicleRequired"
                      label="Do you want to make vehicle mandatory?"
                      ref={chkVehicleRequiredRef}
                      checked={vehicleRequired} // Controlled state
                      onChange={handleCheckboxChange} // Update state on change
                    />
                  </Form>
                </Col>
              </Row>
            </Container>
          </Modal.Body>

        </Modal>

      </HotKeys>
      {props.ShowLoader || ShowGridLoader ? <div className="loader" id={"_loader"}></div> : ""}
      {noDataAlert.show && (
        <Modal
          centered
          show={noDataAlert.show}
          onHide={handleAlertModalClose}
          animation={true}
          backdrop="static"
        >
          <Modal.Header
            className="noshow_dialog_header_bgcolor"
            style={{ height: "50px" }}
            closeButton
          >
            <Modal.Title className="noshow_dialog_title_color">
              {noDataAlert.alertTitle}
            </Modal.Title>
          </Modal.Header>
          <Modal.Body>
            <b>{noDataAlert.alertMsg}</b>
          </Modal.Body>
          <Modal.Footer>
            <Button variant="secondary" onClick={handleAlertModalClose}>
              Ok
            </Button>
          </Modal.Footer>
        </Modal>
      )}
      {invokeAssignComponent && <AssignAction GridRowData={props.GridRowData} selectedDriver={selectedDriver} selectedAffiliate={selectedAffiliate} setAssignProcessing={setAssignAffiliateProcessing}
        selectedVehicle={selectedVehicle} invokeAssignComponent={invokeAssignComponent} chkVehicleRequiredRef={vehicleRequired} BrokerDialogue={true}
        setInvokeAssignComponent={setInvokeAssignComponent} />}
      {invokeUnAssignAffiliateComponent && <UnAssignAffiliateAction GridRowData={props.GridRowData} selectedDriver={selectedDriver}
        selectedVehicle={selectedVehicle} invokeUnAssignComponent={invokeUnAssignAffiliateComponent}
        setInvokeUnAssignComponent={setInvokeUnAssignAffiliateComponent} setUnAssignProcessing={setUnAssignAffiliateProcessing} RefreshGridData={RefreshGridData} />}
      {confimAlert.show && <Modal centered show={confimAlert.show} onHide={handleConfirmCancel} animation={false}>
        <Modal.Header className='noshow_dialog_header_bgcolor' style={{ height: "50px" }} >
          <Modal.Title className='noshow_dialog_title_color'>{confimAlert.alertTitle}</Modal.Title>
        </Modal.Header>
        <Modal.Body><b>{confimAlert.alertMsg}</b></Modal.Body>
        <Modal.Footer>
          {confimAlert.btnCancelText && ( // Only show OK button if btnOkText is not empty or undefined
            <Button variant="secondary" onClick={handleConfirmCancel}>
              {confimAlert.btnCancelText}
            </Button>
          )}
          {confimAlert.btnOkText && ( // Only show OK button if btnOkText is not empty or undefined
            <Button variant="secondary" onClick={handleConfirmOk}>
              {confimAlert.btnOkText}
            </Button>
          )}
        </Modal.Footer>
      </Modal>}
    </>
  );
};
export default BrokerActionsDialog;
